import jwtDecode from 'jwt-decode';
import {
    CognitoIdentityClient,
    GetCredentialsForIdentityCommand,
    GetIdCommand
} from '@aws-sdk/client-cognito-identity';
import { TokenRetriever } from '@amzn/midway-identity-credential-provider/dist/token-retriever';
import { MidwayNetworkPartition, getMidwayHost } from '@amzn/midway-identity-credential-provider/dist/midwayHost';

export class CustomMidwayIdentityProvider {
    TOKEN_TIME_TO_LIVE = 1000 * 60 * 10;

    partition;
    client;
    props;
    midwayHost;

    idTokenExpireTime = 0;
    identityId = '';
    token = '';
    credentials = undefined;

    constructor(props) {
        this.props = props;
        this.partition = MidwayNetworkPartition.AWS;
        this.midwayHost = getMidwayHost(this.partition);
        this.client = new CognitoIdentityClient({
            region: this.props.region,
        });
        this.refresh(() => {});
    }


    refresh(callback) {
        this.refreshTokenAndCredentialsPromise().then(
            () => {
                callback();
            },
            (err) => {
                callback(err);
            },
        );
    }

    async refreshTokenAndCredentialsPromise(){
        if (this.needsRefresh()) {
            await this.refreshTokenPromise();
        }
    }

    needsRefresh(){
        return (
            !this.identityId ||
            !this.token ||
            !this.credentials ||
            Date.now() > this.idTokenExpireTime ||
            this.credentialsNeedRefresh()
        );
    }

    credentialsNeedRefresh(){
        if (this.credentials && this.credentials.Expiration) {
            return Date.now() > this.credentials.Expiration.valueOf();
        }
        return false;
    }

    async refreshTokenPromise() {
        this.token = await TokenRetriever.getTokenOrRedirect(
            this.partition,
            this.props.clientId ? this.props.clientId : window.location.host,
            this.props.redirectUri ? this.props.redirectUri : new URL(window.location.href),
        );

        const { IdentityId } = await this.client.send(
            new GetIdCommand({
                IdentityPoolId: this.props.cognitoIdentityPoolId,
                Logins: {
                    [this.midwayHost]: this.token,
                },
            }),
        );

        this.identityId = IdentityId ? IdentityId: '';
        this.idTokenExpireTime = Date.now() + CustomMidwayIdentityProvider.TOKEN_TIME_TO_LIVE;

        const { Credentials } = await this.client.send(
            new GetCredentialsForIdentityCommand({
                IdentityId: this.identityId,
                Logins: {
                    [this.midwayHost]: this.token,
                },
            }),
        );

        this.credentials = Credentials;
    }

    async getLogin() {
        await this.refreshTokenAndCredentialsPromise();
        if (this.token) {
            const decodedToken = jwtDecode(this.token);
            if (decodedToken.sub) {
                return decodedToken.sub;
            }
        }
    }

    async getCredentials(){
        await this.refreshTokenAndCredentialsPromise();
        return this.credentials;
    }

    async getToken() {
        await this.refreshTokenAndCredentialsPromise();
        return this.token;
    }

    async getIdentityId() {
        await this.refreshTokenAndCredentialsPromise();
        return this.identityId;
    }
}


// WEBPACK FOOTER //
// ./src/client/CustomMidwayIdentityProvider.jsx